import { RunWithPosition } from "types/generated";

export const getAllItemsForSelectAll = (runs: RunWithPosition[]) =>
  new Set(runs.map((run) => run.run.id));
